import { render, staticRenderFns } from "./AlbumNavigationZone.vue?vue&type=template&id=897d251a&scoped=true&"
import script from "./AlbumNavigationZone.vue?vue&type=script&lang=js&"
export * from "./AlbumNavigationZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumNavigationZone.vue?vue&type=style&index=0&id=897d251a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d251a",
  null
  
)

export default component.exports